module.exports = __webpack_public_path__ + "static/usoutsideoxford2withwaitress-2e6fc444df6fb32ef868fc6bb1802a7f.jpg";